
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ onClick, className = '' }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            onClick={handleClick}
            className={`
                group mb-4 flex items-center gap-2 p-2 rounded-xl transition-all
                text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white
                hover:bg-gray-100 dark:hover:bg-white/10
                ${className}
            `}
        >
            <div className="p-1.5 rounded-lg bg-white dark:bg-[#1e1e1e] border border-gray-200 dark:border-gray-700 shadow-sm group-hover:shadow transition-all group-hover:scale-105">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4 transition-transform group-hover:-translate-x-0.5"
                >
                    <path d="m15 18-6-6 6-6" />
                </svg>
            </div>
            <span className="font-bold text-sm">Zurück</span>
        </button>
    );
};

export default BackButton;
